import React from "react";

const Input = ({ placeholder, isservice, type, icon, ...rest }) => {
  return (
    <div className={`flex items-center w-full px-1 py-3 justify-between border-b ${isservice ? "border-troo-white" :" border-troo-secondary "}`}>
      <input
        type={type}
        placeholder={placeholder}
        {...rest}
        className={` bg-transparent outline-none w-full ${
          isservice ? "placeholder-troo-white  " : " placeholder-troo-secondary"
        }`}
      />
      <div className={` text-xl ${isservice ? "text-troo-white" : "text-troo-secondary"}`}>{icon}</div>
    </div>
  );
};

export default Input;
